export const COMMON = {
  app: {
    name: 'ENSTRUCTURE',
  },
  navigation: {
    logout: 'Abmelden',
    expandSidebar: 'Seitenleiste erweitern',
    collapseSidebar: 'Seitenleiste reduzieren',
    darkMode: 'Dunkler Modus',
  },
  text: {
    cancel: 'Abbrechen',
    close: 'Schließen',
    create: 'Erstellen',
    noResults: 'Keine Ergebnisse',
    loading: 'Laden',
    pleaseWaitWhileFetching: 'Bitte warten Sie, während die Daten abgerufen werden.',
    somethingWentWrong: 'Etwas ist schief gelaufen',
    unableToLoadData: 'Daten konnten nicht geladen werden',
    failedToLoadData: 'Fehler beim Laden der Daten',
    pleaseRefreshOrTryAgain: 'Bitte aktualisieren oder erneut versuchen',
    retry: 'Wiederholen',
  },
  validation: {
    required: 'Erforderlich',
    url: 'Ungültige URL',
  },
}
